import { Box, Typography } from "@mui/material";
import { useErrorContext } from "../hooks/useErrorContext";
import ParseHTML from "./ParseHTML";

//This function renders a custom or general error text.
export default function ErrorText() {
    const { error } = useErrorContext();
    console.log('error text', error);

    let text: string = process.env.REACT_APP_GENERAL_ERROR_TEXT ?? '';

    if (error !== null && error.message !== null && error.message.trim() !== '') {
        text = error.message;
    }
    
    return (
        <Box padding={2}>
            <Typography variant="h6" color="secondary.dark" paragraph={true}>{ParseHTML(text)}</Typography>
        </Box>
    );
}